import { userRequests } from '../requests/users.request';
import { createApiThunk } from '../utils/apiThunk';

export const getUsersByIds = createApiThunk(userRequests.getUsersByIds);

